import * as React from 'react'
import { useSelector } from 'react-redux'
import { Box, Typography as MIUTypography, styled } from '@mui/material'
import { DataGrid, gridClasses, esES } from '@mui/x-data-grid'
import { getSpecieTableAll } from '../../../services'
import { grey } from '@mui/material/colors'
import { getColumns } from './columns'
import Botton from '../../BottonCustom'
import { Create } from '@mui/icons-material'
import CreationModal from './CreationModal'
import AlertCustom from '../../Alerts'

const styleContainer = { height: '88vh', width: '100%' }
const COLOR_PRIMARY = 'var(--color-primary)'
const COLOR_WHITE = '#fffafa'

const styleDefault = {
  color: COLOR_PRIMARY,
  border: `1px solid ${COLOR_PRIMARY}`,
  width: '100%',
  fontSize: '12px',
  '&:hover': { backgroundColor: COLOR_PRIMARY, color: COLOR_WHITE },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
}
const styleHeaderTab = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignContent: 'center',
  alignItems: 'baseline',
  ml: 4,
  mb: 1,
}
const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: 650,
  lineHeight: '18px',
  color: '#6A6A6A',
  paddingBottom: 6,
  paddingTop: 6,
  textAlign: 'center',
  marginTop: 12,
  marginBottom: 3,
  height: '5%',
}))

const SpecieTable = ({ setSelectedLink, link }) => {
  const modalRef = React.useRef()
  const alertRef = React.useRef()

  const [data, setData] = React.useState([])
  const [pageSize, setPageSize] = React.useState(20)
  const [rowId, setRowId] = React.useState(null)

  const { isStored } = useSelector(state => state.alertsGlobal)

  const columns = React.useMemo(() => getColumns(rowId, setRowId), [rowId])

  const handleFormCreation = () => {
    modalRef.current.openModal()
  }

  React.useEffect(() => {
    getSpecieTableAll()
      .then(data => setData(data))
      .catch(err => console.log('Error: ', err))
  }, [])

  React.useEffect(() => {
    if (!Boolean(isStored)) return
    getSpecieTableAll()
      .then(data => {
        setData(data)
        alertRef?.current?.openAlert(true)
      })
      .catch(err => console.log('Error: ', err))
  }, [isStored])

  return (
    <Box sx={styleContainer}>
      <Box sx={styleHeaderTab}>
        <Box>
          <Typography>Administrar Especies</Typography>
        </Box>
        <Box>
          <Botton
            text="Nuevo"
            onClick={handleFormCreation}
            startIcon={<Create />}
            styleButton={styleDefault}
            size="small"
          />
        </Box>
      </Box>
      <div style={{ height: '95%', width: '100%' }}>
        <DataGrid
          rows={data}
          columns={columns}
          pageSize={pageSize}
          getRowId={row => row.id}
          rowsPerPageOptions={[20, 50, 100]}
          onPageSizeChange={newPageSize => setPageSize(newPageSize)}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          getRowSpacing={params => ({
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
          })}
          sx={{
            ml: 2,
            [`& .${gridClasses.row}`]: {
              bgcolor: grey[100],
            },
          }}
          onCellEditCommit={params => setRowId(params.id)}
        />
      </div>
      <CreationModal ref={modalRef} />
      <AlertCustom
        ref={alertRef}
        severity={isStored?.stored !== true ? 'warning' : 'success'}>
        {isStored?.stored !== true ? isStored?.message : 'Guardado exitosamente.'}
      </AlertCustom>
    </Box>
  )
}

export default SpecieTable
